<template lang="pug">
  .share
    .share-wrap
      .ctrl-bar(@click='closeShare')
        .close.icon
          i.iconfont.icon-close-outline
      .share-body
        .qr-code.fl
          .img-box
            img(:src='getQrcodeUrl')
        .content.fl(v-if='getPlatform')
          .field
            p 作品地址
              span.copy.fr(@click='handleCopy("workHref")') 复制
            el-input.item(:value="panoUrl", ref='workHref')
          .field
            p 嵌入到网站
              span.copy.fr(@click='handleCopy("frameHref")') 复制
            el-input.item(type='textarea', :rows='3', :value="iframeCode", ref='frameHref')
          .field
            span.copy.fr(@click='handleCopy("viewportHref")') 复制
            el-tooltip(
              effect="dark",
              content="如嵌入后显示异常，请在html页面的head里加入以下代码", placement="right")
              span 异常处理
                i.iconfont.icon-redian
            .item.mt20
              el-input(type='textarea', :rows='3', :value="mateCode", ref='viewportHref')
</template>
<script>
import { mapActions } from 'vuex'
import { isPC } from '@/utils'
import { TOOLBAR_SHARE } from '@/config/contant'
export default {
  data() {
    return {
      isShowContent: false,
      panoUrl: `${window.$globalconfig.URLS.VIDEO_VIEW_PREFIX}${this.$route.query.videoid}`,
      iframeCode: `<iframe src="${window.$globalconfig.URLS.VIDEO_VIEW_PREFIX}${this.$route.query.videoid}" frameborder ="no" border="0" style="width: 100%; height: 600px;"></iframe>`,
      mateCode:
        '<meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">',
      qrcode: `${window.$globalconfig.URLS.API}/api_qrcode.aspx?id=${this.$route.query.videoid}&type=newvideo`,
    }
  },
  mounted() {
    if (isPC()) {
      this.isShowContent = true
    }

    // 监听复制
    document.body.oncopy = e => {
      this.$vgo.tip('复制成功！', 'success')
    }
  },
  computed: {
    getPlatform() {
      return this.isShowContent
    },
    getQrcodeUrl() {
      return (
        window.$global.QrcodeUrl + this.$route.query.videoid + '&type=newvideo'
      )
    },
  },
  methods: {
    ...mapActions({
      toggleVisible: 'TOGGLE_VISIBLE_TYPE',
    }),
    handleCopy(name) {
      let obj = this.$refs[name]
      obj.select()
      document.execCommand('Copy')
    },
    closeShare() {
      this.toggleVisible(TOOLBAR_SHARE)
    },
  },
}
</script>
<style lang="stylus" scoped>
@import '~assets/styles/colors.styl'
@import '~assets/styles/mixins.styl'
@import '~assets/styles/variables.styl'
$modal-width = 800px
$modal-height = 500px
.share
  full-cover()
  background-color: rgba($--color-black, .5)
  z-index: $--zindex-mid
  .share-wrap
    position: absolute
    top: 50%
    left: 50%
    padding: 30px 20px
    border-radius: 4px
    box-sizing: border-box
    transform: translate(-50%, -50%)
    background-color: rgba(251, 251, 251, 0.84)
    .ctrl-bar
      position: absolute
      top: 0
      right: 0
      padding: 10px
      &:hover
        cursor: pointer
        .iconfont
          color: $--color-danger
      .iconfont
        font-size: 30px

    .share-body
      position: relative
      height: 100%
      .qr-code
        position: relative
        width: 300px
        height: 100%
        .img-box
          position: absolute
          left: 50%
          top: 50%
          width: 200px
          height: 200px
          margin: 0 auto
          transform: translate(-50%, -50%)
      .content
        width: calc(100% - 300px)
        height: 100%
        padding:  0 20px
        box-sizing: border-box
        border-left: 1px solid $--color-gray
        .field
          padding: 10px 0
          & > span
            margin-bottom: 10px
          .copy
            font-size: 13px
            color: $--color-gray-light
            cursor: pointer

@media (min-width: 768px)
  .share
    .share-wrap
      width: $modal-width
      height: $modal-height

@media (max-width: 414px)
  .share-wrap
    width: 100%
    height: 300px
    .qr-code
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
</style>
